import * as htmlToImage from 'html-to-image';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {useSelector } from 'react-redux';
import Title from '../../components/Title/Title';
import RoomResult from '../../assets/img/room-result.png'
import copyImg from '../../assets/img/copy.png';
import downlandImg from '../../assets/img/downlandImg.png';
import twitterBlue from '../../assets/img/twitter-blue.png';
import { copyBlobToClipboard } from 'copy-image-clipboard';
import mainLogo from '../../assets/img/logo.png';
import { dataURLtoBlob, loadImage } from '../../utils/utils';
import {
    ActionWrap,
    DraftLogoTeam,
    DraftResultHead,
    DraftResultPick,
    DraftResultPickWrap,
    DraftResultPos,
    DraftResultShare,
    DraftResultsPickWrapper,
    DraftTeam,
    DraftTeamName,
    MockDraftWrap,
    Wrapper,
} from '../DraftResult/DraftResult.styles';
import {selectStimulyatorDrafRoom} from "../../app/features/stimulyatorDraftRoom/stimulyatorDraftRoomSlice";




const DraftResultRoom = () => {
    const domEl = useRef(null);
    const {teamDraftPlayerChoose, round, totalRounds, chosenTeam }=useSelector(selectStimulyatorDrafRoom);
    const selectedTeam = teamDraftPlayerChoose.find(team => team.name === chosenTeam);
    const [copyShow, setCopyShow] = useState(false);
    const [imgBlob, setImgBlob] = useState(null);

    const onButtonClick = useCallback(() => {
        if (domEl.current === null) {
            return;
        }
        htmlToImage
            .toJpeg(domEl.current)
            .then(dataUrl => {
                const link = document.createElement('a');
                link.download = `${selectedTeam.name}-draft-result`;
                link.href = dataUrl;
                link.click();
                console.clear();
            })
            .catch(err => {
                console.log(err);
            });
        }, [domEl]);

    const onCopyImage = useCallback(() => {
        if (domEl.current === null) return;
        htmlToImage.toJpeg(domEl.current)
            .then(dataUrl => loadImage(dataUrl))
            .then(png => {
                const imgBlob = dataURLtoBlob(png);
                setImgBlob(imgBlob);
                setCopyShow(true);
            })
            .catch(err => console.log(err));
    }, [domEl]);

    useEffect(() => {
        if (imgBlob) {
            copyBlobToClipboard(imgBlob)
                .then(() => {
                    setTimeout(() => setCopyShow(false), 2000);
                    console.log("Image copied to clipboard!");
                })
                .catch(error => console.error("Copy failed:", error));
        }
    }, [imgBlob]);

return(
    <>
        <Wrapper className="main-container">
            <Title titleText="Your Mock Draft Result  " titleClassName="draftResultTitle" />
            <DraftResultShare>
                <div className="share-draft-wrap">
                    <div className="share-draft">
                        <p>Share Your Mock Draft Result</p>
                        <div>
                            <img src={twitterBlue} onClick={() => window.open('https://twitter.com/share')} alt="twitter" />
                        </div>
                    </div>
                </div>
            </DraftResultShare>
            <ActionWrap>
                <div className="downland-btn" onClick={onButtonClick}>
                    <img src={downlandImg} alt="download" />
                    <p>Download results image</p>
                </div>
                        <div className="downland-copy" onClick={onCopyImage}>
                            <img src={copyImg} alt="copy"/>
                                <p>
                                    {copyShow ? 'COPIED!' : 'Copy Image'}
                                </p>
                        </div>
            </ActionWrap>
            <DraftResultPick ref={domEl}>
                <DraftResultsPickWrapper>
                    <DraftResultHead>
                    <MockDraftWrap>
                            <DraftTeam>
                                <DraftLogoTeam>
                                    <img src={selectedTeam?.logo} />
                                </DraftLogoTeam>
                                <DraftTeamName>
                                    <h3>{selectedTeam?.name} MOCK DRAFT</h3>
                                    <p>draftprofessor.com</p>
                                </DraftTeamName>
                            </DraftTeam>
                    </MockDraftWrap>
                </DraftResultHead>
                    <DraftResultPickWrap backImg={RoomResult}>
                        <div className="draft-result-logo">
                            <div className="logo">
                                <img src={mainLogo} alt="logo" />
                            </div>
                        </div>
                        <div className="draft-result-item-wrapper">
                            {selectedTeam?.choosePlayers?.map((player, idx) => {
                                return(
                                    <div className="draft-result-pick-item">
                                        <div className="draft-result-pick-item-info">
                                            <div className="draft-result-pick-round">
                                                <p>
                                                    R{idx+1}:{selectedTeam.selection}
                                                </p>
                                            </div>
                                            <div className={"draft-result-pick-part"}>
                                                <div className={"draft-result-pick-part1"}>
                                                    <div className="draft-result-pick-logo">
                                                        <img src={selectedTeam.logo}/>
                                                    </div>
                                                    <div className="draft-result-pick-name">
                                                        <p>{player?.player}</p>
                                                        <p>{player?.college}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"draft-result-pick-part2"}>
                                                <DraftResultPos
                                                    className="draft-result-pick-pos"
                                                >
                                                    <p>{player?.position}</p>
                                                </DraftResultPos>
                                            </div>
                                            <div className="draft-result-pick-rating">
                                                <p>Ranking</p>
                                                <div className="draft-result-pick-rating-item">
                                                    <p>{player.ranking}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            }
                        </div>
                    </DraftResultPickWrap>
                </DraftResultsPickWrapper>
            </DraftResultPick>
        </Wrapper>
    </>
)
}

export default DraftResultRoom;
